<template>
  <Disclosure
    as="template"
    :default-open="
      ['today-achievement', 'week-achievement', 'range-achievement', 'sessions-admin-stats'].includes(
        route.name as string
      )
    "
    v-slot="{ open }"
  >
    <DisclosureButton as="li" class="mt-4 w-full" :class="[]">
      <!-- primary anchor  -->
      <li
        to=""
        class="ease-in-out justify-center text-sm leading-default py-2.7 active after:ease-in-out after:font-awesome-5-free my-0 mx-2 flex items-center whitespace-nowrap px-4 font-medium shadow-none transition-colors after:mr-auto after:inline-block after:font-bold after:text-slate-800/50 after:antialiased after:transition-all after:duration-200 text-white dark:opacity-80 dark:after:text-white/50 dark:after:text-white cursor-pointer"
      >
        <!-- big anchor expandable -->

        <div
          class="stroke-none flex items-center justify-center rounded-lg bg-center fill-current px-2.5 text-center"
        >
          <span class="icon-[iconoir--reports] size-5"></span>
        </div>

        <span class="duration-300 pointer-events-none ease opacity-100" v-if="globalStore.isToggled"
          >التقارير</span
        >
        <!-- primary span -->
      </li>
    </DisclosureButton>
    <DisclosurePanel>
      <!-- <li
        class="mt-2 w-full"
        :class="[globalStore ? 'mr-0' : 'mr-5', !globalStore.isToggled && 'justify-center']"
        @click="isSmallScreen ? globalStore.toggleSidebar() : ''"
      >
        <RouterLink
          :to="{ name: 'today-achievement' }"
          class="ease-in-out text-sm leading-default py-2.7 active after:ease-in-out after:font-awesome-5-free my-0 mx-2 flex items-center whitespace-nowrap px-4 font-medium shadow-none transition-colors after:mr-auto after:inline-block after:font-bold after:text-slate-800/50 after:antialiased after:transition-all after:duration-200 text-white dark:opacity-80 dark:after:text-white/50 dark:after:text-white"
          aria-expanded="false"
        >
          <div
            class="stroke-none flex items-center justify-center rounded-lg bg-center fill-current px-2.5 text-center"
          >
            <span class="icon-[gg--calendar-today] size-5"></span>
          </div>
          <span
            class="mr-1 duration-300 pointer-events-none ease opacity-100"
            v-if="globalStore.isToggled"
            >إنجاز اليوم</span
          >
        </RouterLink>
      </li>

      <li
        class="mt-2 w-full"
        :class="[globalStore ? 'mr-0' : 'mr-5', !globalStore.isToggled && 'justify-center']"
        @click="isSmallScreen ? globalStore.toggleSidebar() : ''"
      >
        <RouterLink
          :to="{ name: 'week-achievement' }"
          class="ease-in-out text-sm leading-default py-2.7 active after:ease-in-out after:font-awesome-5-free my-0 mx-2 flex items-center whitespace-nowrap px-4 font-medium shadow-none transition-colors after:mr-auto after:inline-block after:font-bold after:text-slate-800/50 after:antialiased after:transition-all after:duration-200 text-white dark:opacity-80 dark:after:text-white/50 dark:after:text-white"
          aria-expanded="false"
        >
          <div
            class="stroke-none flex items-center justify-center rounded-lg bg-center fill-current px-2.5 text-center"
          >
            <span class="icon-[bi--calendar4-week] size-4"></span>
          </div>
          <span
            class="mr-1 duration-300 pointer-events-none ease opacity-100"
            v-if="globalStore.isToggled"
            >إنجاز الأسبوع</span
          >
        </RouterLink>
      </li> -->

      <li
        class="mt-2 w-full"
        :class="[globalStore ? 'mr-0' : 'mr-5', !globalStore.isToggled && 'justify-center']"
        @click="isSmallScreen ? globalStore.toggleSidebar() : ''"
      >
        <RouterLink
          :to="{ name: 'range-achievement' }"
          class="ease-in-out text-sm leading-default py-2.7 active after:ease-in-out after:font-awesome-5-free my-0 mx-2 flex items-center whitespace-nowrap px-4 font-medium shadow-none transition-colors after:mr-auto after:inline-block after:font-bold after:text-slate-800/50 after:antialiased after:transition-all after:duration-200 text-white dark:opacity-80 dark:after:text-white/50 dark:after:text-white"
          aria-expanded="false"
        >
          <div
            class="stroke-none flex items-center justify-center rounded-lg bg-center fill-current px-2.5 text-center"
          >
            <span class="icon-[bi--calendar4-range] size-4"></span>
          </div>
          <span
            class="mr-1 duration-300 pointer-events-none ease opacity-100"
            v-if="globalStore.isToggled"
            >إنجاز الفترة</span
          >
        </RouterLink>
      </li>
      <li
        class="mt-2 w-full"
        :class="[globalStore ? 'mr-0' : 'mr-5', !globalStore.isToggled && 'justify-center']"
        v-if="ability.can('view', 'AdminStats')"
        @click="isSmallScreen ? globalStore.toggleSidebar() : ''"
      >
        <RouterLink
          :to="{ name: 'sessions-admin-stats' }"
          class="ease-in-out text-sm leading-default py-2.7 active after:ease-in-out after:font-awesome-5-free my-0 mx-2 flex items-center whitespace-nowrap px-4 font-medium shadow-none transition-colors after:mr-auto after:inline-block after:font-bold after:text-slate-800/50 after:antialiased after:transition-all after:duration-200 text-white dark:opacity-80 dark:after:text-white/50 dark:after:text-white"
          aria-expanded="false"
        >
          <div
            class="stroke-none flex items-center justify-center rounded-lg bg-center fill-current px-2.5 text-center"
          >
            <span class="icon-[tabler--chart-pie] size-5"></span>
          </div>
          <span
            class="mr-1 duration-300 pointer-events-none ease opacity-100"
            v-if="globalStore.isToggled"
            >تقارير الادارة</span
          >
        </RouterLink>
      </li>
    </DisclosurePanel>
  </Disclosure>
</template>

<script setup lang="ts">
import { auth } from '@/stores/auth'
import { useGlobalStore } from '@/stores/global'
import { Disclosure, DisclosureButton, DisclosurePanel } from '@headlessui/vue'
import { ChevronUpIcon } from '@heroicons/vue/20/solid'
import { ChartBarIcon, PresentationChartBarIcon } from '@heroicons/vue/24/outline'
import { useMediaQuery } from '@vueuse/core'
import { useRoute } from 'vue-router'

const isSmallScreen = useMediaQuery('(max-width: 640px)')
const globalStore = useGlobalStore()

const route = useRoute()
const { ability } = auth()
</script>

<style></style>
